import {
  CartesianGrid,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { compactFormatKRW } from '../../../utils/formatKRW';
import { RetirementHistory } from '../RetirementPage.hooks';

interface RetirementChartProps {
  histories: RetirementHistory[];
  depletionAge: number | null;
}

function RetirementChart({ histories, depletionAge }: RetirementChartProps) {
  const yearlyData = histories.filter((_, i) => i % 12 === 0);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={yearlyData} margin={{ top: 8, right: 8, bottom: 0, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
        <XAxis
          dataKey="age"
          tickFormatter={(v) => `${v}세`}
          axisLine={false}
          tickLine={false}
          style={{ fontSize: '0.75rem' }}
        />
        <YAxis
          tickFormatter={(v) => compactFormatKRW(v)}
          axisLine={false}
          tickLine={false}
          style={{ fontSize: '0.6875rem' }}
          width={72}
        />
        <Tooltip
          formatter={((v: number) => [compactFormatKRW(v), '잔여 자산']) as any}
          labelFormatter={(l) => `${l}세`}
        />
        <Line
          type="monotone"
          dataKey="asset"
          stroke="#3b82f6"
          strokeWidth={2}
          dot={false}
        />
        {depletionAge !== null && (
          <ReferenceLine
            x={depletionAge}
            stroke="#ef4444"
            strokeDasharray="4 4"
            label={{ value: `${depletionAge}세 소진`, position: 'top', fill: '#ef4444', fontSize: 12 }}
          />
        )}
      </LineChart>
    </ResponsiveContainer>
  );
}

export default RetirementChart;
